import { Controller } from 'stimulus'
import Modal from 'bootstrap/js/src/modal'

const USER_PATH = window.env.USER_PATH

export default class extends Controller {
  static targets = [
    'addressType',
    'cityError',
    'cityLabel',
    'countryError',
    'countryLabel',
    'countryLabel',
    'field',
    'firstNameError',
    'firstNameLabel',
    'lastNameError',
    'lastNameLabel',
    'messages',
    'phoneError',
    'phoneLabel',
    'streetError',
    'streetLabel',
    'submitButton',
    'zipCodeError',
    'zipCodeLabel'
  ]

  connect () {
    this.clearErrors()
    this.setupModal()
  }

  setupModal () {
    if (!this._modal) {
      const modal = document.getElementById('addressBookModal')
      modal.addEventListener('hidden.bs.modal', this.handleModalClose.bind(this))
      if (modal) {
        this._modal = Modal.getInstance(modal)
      }
    }
  }

  disconnect () {
    if (this.modal) {
      this.modal._element.removeEventListener('hidden.bs.modal', this.handleModalClose.bind(this))
    }
  }

  handleModalClose () {
    this.clearErrors()
  }

  get modal () {
    return this._modal
  }

  async submit (event) {
    event.preventDefault()

    this.clearErrors()
    this.disableSubmit()

    const form = event.target.closest('form')
    const formData = new FormData(form)
    const filteredData = this.filterFormData(formData)

    try {
      const response = await fetch(form.action, {
        method: form.method,
        body: filteredData,
        headers: {
          'X-CSRF-Token': document.querySelector("[name='csrf-token']").content,
          Accept: 'application/json'
        },
        credentials: 'same-origin'
      })

      const data = await response.json()
      if (response.ok) {
        this.handleSuccess(data)
      } else {
        this.handleErrors(data.errors)
      }
    } catch (error) {
      this.handleNetworkError(error)
    } finally {
      this.enableSubmit()
    }
  }

  filterFormData (formData) {
    const filtered = new FormData()

    for (const [key, value] of formData.entries()) {
      // Only add non-null, non-undefined, and non-empty string values
      if (value !== null &&
        value !== undefined &&
        value !== 'null' &&
        value !== 'undefined') {
        filtered.append(key, value)
      }
    }

    return filtered
  }

  handleSuccess (data) {
    this.showMessage('Adresse erfolgreich gespeichert!', 'success')

    // Close modal after success
    setTimeout(() => {
      this.dispatch('saved', { detail: { address: data } })
      window.location.href = USER_PATH
    }, 2500)
  }

  handleErrors (errors) {
    Object.entries(errors).forEach(([field, messages]) => {
      this.displayFieldError(field, messages[0])
    })
  }

  displayFieldError (field, message) {
    const camelCasedField = this.camelCase(field)
    const errorTarget = this[`${camelCasedField}ErrorTarget`]

    if (errorTarget) {
      errorTarget.textContent = message
      errorTarget.style.display = 'block'

      const formControl = this.findFormControl(errorTarget)
      if (formControl) {
        formControl.classList.add('is-invalid')
      }

      // Find and style the associated label
      const label = this[`${camelCasedField}LabelTarget`]
      if (label) {
        label.classList.add('text-danger')
      }
    }
  }

  findFormControl (errorElement) {
    // Check if previous sibling is a form control
    const prev = errorElement.previousElementSibling
    if (prev && (prev.classList.contains('form-control') || prev.tagName === 'INPUT' || prev.tagName === 'SELECT' || prev.tagName === 'TEXTAREA')) {
      return prev
    }

    // Check if there's a form control in a parent wrapper
    const parent = errorElement.parentElement
    if (parent) {
      return parent.querySelector('.form-control, input[type="text"], input[type="email"], input[type="tel"], select, textarea')
    }

    return null
  }

  handleNetworkError (error) {
    this.showMessage('Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.', 'error')
    console.error('Network error:', error)
  }

  showMessage (message, type) {
    const alertClass = type === 'success' ? 'alert-success' : 'alert-danger'
    this.messagesTarget.innerHTML = `
      <div class="alert ${alertClass} alert-dismissible fade show" role="alert">
        ${message}
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>
    `
  }

  clearErrors () {
    // Clear all error messages and remove is-invalid class from form controls
    this.element.querySelectorAll('.invalid-feedback').forEach(el => {
      el.textContent = ''
      el.style.display = 'none'

      // Find and remove is-invalid class from sibling form control
      const formControl = this.findFormControl(el)
      if (formControl) {
        formControl.classList.remove('is-invalid')
      }
    })

    // Remove text-danger class from all labels
    this.element.querySelectorAll('.text-danger').forEach(label => {
      label.classList.remove('text-danger')
    })

    if (this.hasMessagesTarget) {
      this.messagesTarget.innerHTML = ''
    }
  }

  disableSubmit () {
    this.submitButtonTarget.disabled = true
    this.submitButtonTarget.textContent = 'Wird gespeichert...'
  }

  enableSubmit () {
    this.submitButtonTarget.disabled = false
    this.submitButtonTarget.textContent = 'Erstellen'
  }

  camelCase (str) {
    return str.replace(/_([a-z])/g, (g) => g[1].toUpperCase())
  }
}
